<template>
<div>
  <v-toolbar flat>
    <v-toolbar-title>{{ label }}</v-toolbar-title>
    <v-dialog persistent v-model="dialog" max-width="800px">
      <v-btn color="teal" round dark class="mb-2" slot="activator">{{ $t("form.inputs.table.new-record") }}</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <div style="margin-top:20px" v-for="field in field['sub-fields']" :key="field.id + model.length + editedIndex">
              <component v-if="!isHiddenField(field)" :field="field" :key="field.name + field.order + model.length + editedIndex" :context="getContext()" :is="getInputComponent(field.type)" :value="getValue(field.order)"
                @setValue="setValue($event, field)">
              </component>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">{{ $t("base.cancel") }}</v-btn>
          <v-btn color="blue darken-1" flat @click="save">{{ $t("base.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>

  <v-data-table :headers="headers" :items="model" :rows-per-page-text="tableTranslations.rowsPerPageText" :no-data-text="tableTranslations.noDataText" :no-results-text="tableTranslations.noResultsText"
    :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination" class="elevation-1">

    <template slot="headers" slot-scope="props">
      <tr>
        <th class="header" style="word-wrap: break-word; white-space: normal" v-for="(header,index) in props.headers" :key="header.text+'_'+index">
          <span> {{ header.text }} </span>
        </th>
      </tr>
    </template>

    <template slot="items" slot-scope="props">
      <td class="text-xs-center pretty-display" v-for="(dynamic, index) in dynamicHeaders" :key="index">

        <div v-if='dynamic.type === "signature"'>
          <img v-if="props.item[dynamic.value] != null && props.item[dynamic.value].length >10 " class="imageField" :src="'data:image/png;base64,'+props.item[dynamic.value]" />
          <div v v-else>Brak</div>
        </div>

        <div v-else-if='dynamic.type === "photo"'>
          <img v-if="props.item[dynamic.value] != null && props.item[dynamic.value].length >10 " class="imageField" :src="'data:image/jpg;base64,'+props.item[dynamic.value]" />
          <div v-else>Brak</div>
        </div>

        <div v-else-if='dynamic.type === "radio"'>
          {{ InputHelper.getRadioObjectByKey( field['sub-fields'][dynamic.value-1], props.item[dynamic.value] )  }}
        </div>
        <div v-else-if='dynamic.type === "checkbox"'>
          {{ InputHelper.getCheckboxStringValues(field['sub-fields'][dynamic.value-1], props.item[dynamic.value])  }}
        </div>

        <div v-else-if='dynamic.type === "storage" && props.item[dynamic.value] != null'>
          {{ props.item[dynamic.value].amount }} - {{ props.item[dynamic.value].productName }}
        </div>

        <div v-else>
          <span> {{props.item[dynamic.value] }}</span>
        </div>
      </td>

      <td class="text-xs-center pretty-display">
        <v-icon small class="mr-2" @click="editItem(props.index)">
          edit
        </v-icon>
        <v-icon small @click="deleteItem(props.item)">
          delete
        </v-icon>
      </td>
    </template>
  </v-data-table>
  {{ description }}
</div>
</template>

<script>
import {input} from '@/mixins/input'
import TextInput from "./Text"
import NumberInput from "./Number"
import DateInput from "./Date"
import TimeInput from "./Time"
import RadioInput from "./Radio"
import MultipleInput from "./Multiple"
import SignatureInput from "./Signature"
import PhotoInput from "./Photo"
import DependInput from "./SelectDepend"
import CodeInput from "./Code"
import ArchiveInput from "./Archive"
import RelatedInput from "./Related"
import CheckboxInput from "./Checkbox"
import StorageInput from "./Storage"
import Vue from 'vue'
import fieldType from '@/enums/fieldType'
import Context from '@/plugins/Context'
import InputHelper from '@/plugins/InputHelper'
import Acl from '@/plugins/Acl'

export default {
  name: "Fill-table",
  components: {
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    DependInput,
    CheckboxInput,
    StorageInput
  },
  mixins: [input],
  data: () => ({
    acl: new Acl(),
    InputHelper,
    pagination: {
      rowsPerPage: 10
    },
    dateFromCreation: [],
    dialog: false,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    Context
  }),
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Nowy rekord' : 'Edytuj rekord'
    },
    dynamicHeaders() {
      return this.field["sub-fields"].filter(subField => !fieldType.notUpdate.includes(subField.type))
        .map(subField => {
          let header = {
            text: subField.name,
            value: String(subField.order),
            type: subField.type,
            description: subField.description
          }
          if (['select', 'autocomplete', 'radio', 'checkbox', 'formule'].indexOf(subField.type_id)) {
            header.values = subField.values
          }
          return header
        })
    },
    headers() {
      let headers = this.field["sub-fields"].filter(subField => !fieldType.notUpdate.includes(subField.type))
        .map(subField => {
          return {
            text: subField.name,
            value: String(subField.order),
            sortable: false
          }
        })
      headers.push({
        text: 'Akcje',
        value: 'name',
        sortable: false,
        class: 'justify-center'
      })
      return headers
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.model = []
    if (this.value != undefined && this.value.length > 0) {
      this.value.forEach((row, i) => {
        this.dateFromCreation[i] = {created_by: row.created_by, id: row.id, created_at: row.created_at}
        let rowRes = {}
        row.results.forEach(fieldRes => {
          rowRes[fieldRes.order] = fieldRes.value
        })
        this.model.push(rowRes)
      })
    }
  },
  methods: {
    getContext() {
      return Context.createTableContextWithParent(this.context, 0, this.field['sub-fields'])
    },
    isHiddenField(field) {
      return fieldType.hidden.includes(field.type)
    },
    getFieldInfo(id) {
      let mainField = this.$parent.getFieldInfo(id)
      if (mainField != undefined) return mainField
      return this.getSubFieldInfo(id)
    },
    getSubFieldInfo(id) {
      for (let key in this.field['sub-fields']) {
        if (this.field['sub-fields'][key].id == id) {
          return this.field['sub-fields'][key]
        }
      }
    },
    getFieldValue(id) {
      let field = this.getSubFieldInfo(id)

      if (field != undefined) {
        return this.editedItem[field.order]
      }
      return this.$parent.getFieldValue(id)
    },
    getInputComponent(type) {
      return type + "-input"
    },
    getValue(order) { //TODO change name
      if (this.editedIndex === -1) {
        let field = this.field['sub-fields'].find(el => el.order == order)
        this.setValue('', field)
        return ''
      } else {
        this.model[this.editedIndex][order] //todo
      }
    },
    editItem(index) {
      this.editedIndex = index
      this.editedItem = Object.assign({}, this.model[index])
      this.dialog = true
    },
    deleteItem(item) {
      const index = this.model.indexOf(item)
      this.model.splice(index, 1)
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save() {
      if (this.editedIndex > -1) {
        Vue.set(this.model, this.editedIndex, this.editedItem)
      } else {
        this.model.push(Object.assign({}, this.editedItem))
      }
      this.close()
    },
    setValue(val, field) {
      Vue.set(this.editedItem, field.order, val)
    },
    beforeSend(val) {
      let newVal = []
      val.forEach((row, i) => {
        let newRow = {
          results: []
        }
        for (var key in row) {
          newRow.results.push({
            order: key,
            value: row[key]
          })
        }

        if (this.dateFromCreation[i] && this.dateFromCreation[i].created_by) {
          newRow.created_by = this.dateFromCreation[i].created_by
          newRow.created_at = this.dateFromCreation[i].created_at
          newRow.updated_by = this.acl.user.id
          newRow.id = this.dateFromCreation[i].id
        }


        newVal.push(newRow)
      })
      return newVal
    }
  }
}
</script>

<style>
.table-action-col {
  padding-top: 10px;
}

.header {
  width: 200px;
}

.pretty-display {
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  width: 200px;
}

.imageField {
  width: 100px;
}
</style>
